module.exports = __webpack_public_path__ + "img/1.47d6ca46.png";